// Mock time-related data for Tiritix analytics platform

// Monthly sales data for the past year across product categories
export const monthlySalesByCategory = [
  {
    month: '2024-04',
    Electronics: 2400000,    // Peak - Electronics taking the lead
    Clothing: 1650000,       // Stable
    'Home Appliances': 1350000, // Mid-cycle peak
    Furniture: 1050000,
    Beauty: 720000,          // Continuing decline
  },
  {
    month: '2024-03',
    Electronics: 2320000,    // Strong growth continues
    Clothing: 1680000,
    'Home Appliances': 1280000, // Mid-cycle
    Furniture: 1020000,
    Beauty: 780000,          // Declining
  },
  {
    month: '2024-02',
    Electronics: 2220000,    // Rising strongly
    Clothing: 1720000,
    'Home Appliances': 1200000, // Lower in cycle
    Furniture: 980000,
    Beauty: 840000,          // Still higher but declining
  },
  {
    month: '2024-01',
    Electronics: 2100000,    // Growing rapidly
    Clothing: 1750000,
    'Home Appliances': 1150000, // Cycle low
    Furniture: 960000,
    Beauty: 920000,          // Peak before decline
  },
  {
    month: '2023-12',
    Electronics: 1980000,    // Holiday boost, rising trend
    Clothing: 1820000,       // Peak clothing season
    'Home Appliances': 1220000, // Rising in cycle
    Furniture: 1120000,
    Beauty: 980000,          // Near peak
  },
  {
    month: '2023-11',
    Electronics: 1850000,    // Steady growth
    Clothing: 1780000,
    'Home Appliances': 1300000, // Cycle peak
    Furniture: 1040000,
    Beauty: 1020000,         // Peak
  },
  {
    month: '2023-10',
    Electronics: 1720000,    // Building momentum
    Clothing: 1720000,       // Crossover point - same level
    'Home Appliances': 1350000, // High in cycle
    Furniture: 990000,
    Beauty: 1050000,         // Still leading
  },
  {
    month: '2023-09',
    Electronics: 1600000,    // Growing from lower base
    Clothing: 1680000,
    'Home Appliances': 1280000, // Mid-cycle
    Furniture: 980000,
    Beauty: 1100000,         // Leading
  },
  {
    month: '2023-08',
    Electronics: 1500000,    // Lower but building
    Clothing: 1650000,
    'Home Appliances': 1180000, // Cycle low
    Furniture: 960000,
    Beauty: 1150000,         // Strong position
  },
  {
    month: '2023-07',
    Electronics: 1420000,    // Starting to build
    Clothing: 1620000,
    'Home Appliances': 1120000, // Low point
    Furniture: 950000,
    Beauty: 1200000,         // Peak
  },
  {
    month: '2023-06',
    Electronics: 1350000,    // Lower base
    Clothing: 1580000,
    'Home Appliances': 1180000, // Rising from low
    Furniture: 940000,
    Beauty: 1220000,         // Highest point
  },
  {
    month: '2023-05',
    Electronics: 1300000,    // Lowest point, ready to grow
    Clothing: 1550000,
    'Home Appliances': 1250000, // Cycle building
    Furniture: 920000,
    Beauty: 1200000,         // Strong but will decline
  }
];

// Weekly sales data for the last quarter (partial data)
export const weeklySalesByCategory = [
  {
    week: '2024-W17',
    Electronics: 600000,
    Clothing: 412500,
    'Home Appliances': 337500,
    Furniture: 262500,
    Beauty: 180000
  },
  {
    week: '2024-W16',
    Electronics: 590000,
    Clothing: 420000,
    'Home Appliances': 320000,
    Furniture: 257500,
    Beauty: 185000
  },
  {
    week: '2024-W15',
    Electronics: 580000,
    Clothing: 425000,
    'Home Appliances': 325000,
    Furniture: 255000,
    Beauty: 190000
  },
  {
    week: '2024-W14',
    Electronics: 575000,
    Clothing: 415000,
    'Home Appliances': 315000,
    Furniture: 252500,
    Beauty: 195000
  },
  {
    week: '2024-W13',
    Electronics: 570000,
    Clothing: 410000,
    'Home Appliances': 310000,
    Furniture: 250000,
    Beauty: 200000
  }
];

// Quarterly data for year-over-year comparison
export const quarterlySalesData = [
  {
    quarter: 'Q1 2024',
    Electronics: 6642000,
    Clothing: 5150000,
    'Home Appliances': 3630000,
    Beauty: 2540000,
    Furniture: 2960000
  },
  {
    quarter: 'Q4 2023',
    Electronics: 5550000,
    Clothing: 5380000,
    'Home Appliances': 3970000,
    Beauty: 3150000,
    Furniture: 3120000
  },
  {
    quarter: 'Q3 2023',
    Electronics: 4570000,
    Clothing: 4950000,
    'Home Appliances': 3580000,
    Beauty: 3450000,
    Furniture: 2890000
  },
  {
    quarter: 'Q2 2023',
    Electronics: 4230000,
    Clothing: 4750000,
    'Home Appliances': 3610000,
    Beauty: 3620000,
    Furniture: 2810000
  }
];

// Regional sales trends (showing different patterns across regions)
export const regionalSalesTrends = [
  {
    month: '2024-04',
    'North America': 4200000,
    Europe: 3800000,
    Asia: 4500000,
    'South America': 1200000,
    Oceania: 800000
  },
  {
    month: '2024-03',
    'North America': 4100000,
    Europe: 3750000,
    Asia: 4400000,
    'South America': 1150000,
    Oceania: 750000
  },
  {
    month: '2024-02',
    'North America': 4000000,
    Europe: 3700000,
    Asia: 4300000,
    'South America': 1100000,
    Oceania: 700000
  },
  {
    month: '2024-01',
    'North America': 3950000,
    Europe: 3650000,
    Asia: 4200000,
    'South America': 1080000,
    Oceania: 680000
  },
  {
    month: '2023-12',
    'North America': 4300000,
    Europe: 3900000,
    Asia: 4600000,
    'South America': 1250000,
    Oceania: 850000
  },
  {
    month: '2023-11',
    'North America': 4000000,
    Europe: 3700000,
    Asia: 4300000,
    'South America': 1150000,
    Oceania: 750000
  }
];



// Monthly sales by region (missing export)
export const monthlySalesByRegion = [
  {
    month: '2024-04',
    'North America': 4200000,
    Europe: 3800000,
    Asia: 4500000,
    'South America': 1200000,
    Oceania: 800000
  },
  {
    month: '2024-03',
    'North America': 4100000,
    Europe: 3750000,
    Asia: 4400000,
    'South America': 1150000,
    Oceania: 750000
  },
  {
    month: '2024-02',
    'North America': 4000000,
    Europe: 3700000,
    Asia: 4300000,
    'South America': 1100000,
    Oceania: 700000
  },
  {
    month: '2024-01',
    'North America': 3950000,
    Europe: 3650000,
    Asia: 4200000,
    'South America': 1080000,
    Oceania: 680000
  },
  {
    month: '2023-12',
    'North America': 4300000,
    Europe: 3900000,
    Asia: 4600000,
    'South America': 1250000,
    Oceania: 850000
  },
  {
    month: '2023-11',
    'North America': 4000000,
    Europe: 3700000,
    Asia: 4300000,
    'South America': 1150000,
    Oceania: 750000
  },
  {
    month: '2023-10',
    'North America': 3900000,
    Europe: 3650000,
    Asia: 4200000,
    'South America': 1100000,
    Oceania: 720000
  },
  {
    month: '2023-09',
    'North America': 3850000,
    Europe: 3600000,
    Asia: 4100000,
    'South America': 1080000,
    Oceania: 700000
  },
  {
    month: '2023-08',
    'North America': 3800000,
    Europe: 3550000,
    Asia: 4000000,
    'South America': 1050000,
    Oceania: 680000
  },
  {
    month: '2023-07',
    'North America': 3750000,
    Europe: 3500000,
    Asia: 3950000,
    'South America': 1020000,
    Oceania: 660000
  },
  {
    month: '2023-06',
    'North America': 3700000,
    Europe: 3450000,
    Asia: 3900000,
    'South America': 1000000,
    Oceania: 650000
  },
  {
    month: '2023-05',
    'North America': 3650000,
    Europe: 3400000,
    Asia: 3850000,
    'South America': 980000,
    Oceania: 630000
  }
];

// Seasonal trends by category (missing export)
export const seasonalTrendsByCategory = [
  {
    season: 'Q1 2024',
    Electronics: 6642000,
    Clothing: 5150000,
    'Home Appliances': 3630000,
    Beauty: 2540000,
    Furniture: 2960000
  },
  {
    season: 'Q4 2023',
    Electronics: 5550000,
    Clothing: 5380000,
    'Home Appliances': 3970000,
    Beauty: 3150000,
    Furniture: 3120000
  },
  {
    season: 'Q3 2023',
    Electronics: 4570000,
    Clothing: 4950000,
    'Home Appliances': 3580000,
    Beauty: 3450000,
    Furniture: 2890000
  },
  {
    season: 'Q2 2023',
    Electronics: 4230000,
    Clothing: 4750000,
    'Home Appliances': 3610000,
    Beauty: 3620000,
    Furniture: 2810000
  }
];

// Holiday season impact data (missing export)
export const holidaySeasonImpact = [
  {
    period: 'Black Friday 2023',
    Electronics: 1200000,
    Clothing: 890000,
    'Home Appliances': 650000,
    Beauty: 420000,
    Furniture: 380000,
    baselineLift: 2.3
  },
  {
    period: 'Cyber Monday 2023',
    Electronics: 1350000,
    Clothing: 780000,
    'Home Appliances': 580000,
    Beauty: 380000,
    Furniture: 320000,
    baselineLift: 2.1
  },
  {
    period: 'Christmas Week 2023',
    Electronics: 980000,
    Clothing: 1200000,
    'Home Appliances': 720000,
    Beauty: 650000,
    Furniture: 450000,
    baselineLift: 1.8
  },
  {
    period: 'New Year 2024',
    Electronics: 680000,
    Clothing: 520000,
    'Home Appliances': 890000,
    Beauty: 380000,
    Furniture: 290000,
    baselineLift: 1.4
  },
  {
    period: 'Valentine\'s Day 2024',
    Electronics: 450000,
    Clothing: 720000,
    'Home Appliances': 320000,
    Beauty: 890000,
    Furniture: 180000,
    baselineLift: 1.6
  }
];



// Year-over-year growth data (missing export)
export const yearOverYearGrowth = [
  {
    category: 'Electronics',
    growth2023: 12.5,
    growth2024: 23.1,
    forecast2025: 18.7
  },
  {
    category: 'Clothing',
    growth2023: 8.2,
    growth2024: 7.8,
    forecast2025: 6.5
  },
  {
    category: 'Home Appliances',
    growth2023: 15.3,
    growth2024: 16.4,
    forecast2025: 14.8
  },
  {
    category: 'Beauty',
    growth2023: 11.8,
    growth2024: -2.7,
    forecast2025: -5.2
  },
  {
    category: 'Furniture',
    growth2023: 9.4,
    growth2024: 14.1,
    forecast2025: 12.3
  }
];


export default {
  monthlySalesByCategory,
  monthlySalesByRegion,
  weeklySalesByCategory,
  quarterlySalesData,
  regionalSalesTrends,
  seasonalTrendsByCategory,
  holidaySeasonImpact,
  yearOverYearGrowth
};
